module.exports = __webpack_public_path__ + "img/brand-flixbus.80a55e14.svg";